<template>
 <!-- :style="{paddingLeft: info.picture ? '185px' : '20px'}" -->
<div class="cardContainer clearfix" @click="$emit('clickEven',info)" :class="info.isOnline=='离线'?'active':info.isAlarm=='报警中'?'active1':'active2'">
  <!-- <div class="img imgBox" v-if="info.picture"><img :src="info.picture" alt=""></div> -->
  <div class="text">
    <h4 :title="info.name">{{info.name}}</h4>
    <div class="infoList">
      <dl>
        <dd v-for="(field,index) in showFields" :key="index">
          <span class="mess messOnline" :class="[info[field.field] == '在线' ? 'normal' : 'abnormal']" v-if="field.field === 'isOnline'">
            <i></i><span>{{info[field.field]}}</span>
          </span>
          <span class="mess messAlarm" :class="[info[field.field] == '正常' ? 'normal' : 'abnormal']" v-else-if="field.field === 'isAlarm'&&info.isOnline == '在线'">
            <i></i><span>{{info[field.field]}}</span>
          </span>
          <span class="messOther" :title="info[field.field]" v-else>
            <span v-if="field.field !== 'isAlarm'">{{field.name ? (field.name + '：') : ''}}{{info[field.field]}}</span>
          </span>
        </dd>
      </dl>
    </div>
    <div class="handleBtns">
      <!-- <div class="seeBtn" @click="$emit('details',info.id)">查看</div>
      <div class="editBtn" @click="$emit('edit',info.id)">编辑</div>
      <div class="delBtn" @click="$emit('del',info.id)">删除</div> -->
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    who: {
      type: String,
      default: ''
    },
    showFields: {
      type: Array,
      default: () => {
        return []
      }
    },
    handles: {
      type: Array,
      default: () => {
        return ['details', 'edit', 'del']
      }
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  created() {
    // console.log(this.who)
    // console.log(this.info);
  },
  methods:{
  }
}
</script>

<style lang="scss" scoped>
.cardContainer {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  position: relative;
  box-shadow: 0px 0px 30px 0px rgba(220, 236, 248, 0.69);
  border-radius: 2px;
  background: #fff;
  cursor: pointer;
  &.active{
    border-top: 3px #B8BABC solid;
    .text {
      h4{
        color: #999B9E;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .infoList{
      dl{
        dd{
          &:nth-child(3){
            width: 100% !important;
          }
          &:nth-child(4){
            display: none;
          }
          width: 100%;
          .messOther{
            color: #B8BABC;
          }
        }
      }
    }
  }
  &.active1{
    border-top: 3px #F43300 solid;
    .text {
      h4{
        color: #F43300;
      }
    }
    .infoList{
      dl{
        dd{
          .messOther{
            color: #F76640;
          }
        }
      }
    }
  }
  &.active2{
    border-top: 3px #08BB80 solid;
  }
  .img {
    position: absolute;
    top: 25px;
    left: 20px;
    width: 150px;
    height: 150px;
  }

  .text {
    width: 100%;

    h4 {
      height: 24px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      font-size: 18px;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: calc(100% - 65px);
    }

    .infoList {
      // height: 75px;
      margin: 15px 0;
      font-size: 0;
      dl {
        overflow: hidden;
        dd {
          float: left;
          width: 100%;
          font-size: 14px;
          height: 26px;
          line-height: 26px;
          color: rgba(0, 0, 0, 0.5);
          letter-spacing: 1px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .messOther{}
          .mess{
            display: inline-block;
            width: 80px;
            height: 26px;
            border-radius: 13px;
            text-align: center;
            overflow: hidden;
            i{
              float: left;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              margin: 10px 10px 0 10px;
            }
            span{
              float: left;
            }
          }
          &:nth-child(4){
            width: 36%;
            .messAlarm{
              &.normal {
                background: #E6F8F2;
                color: #08BB80;
                i{
                  background: #08BB80;
                }
              }
              &.abnormal {
                background: #FDEAE5 ;
                color: #F43300;
                i{
                  background: #F43300;
                }
              }
            }
          }
          &:nth-child(3){
            width: 36%;
            .messOnline{
              &.normal {
                background: #E7F3FF;
                color: #1089FF;
                i{
                  background: #1089FF;
                }
              }

              &.abnormal {
                background: #EEEFEF;
                color: #999B9E;
                i{
                  background: #999B9E;
                }
              }
            }
          }
        }
      }
    }

    .handleBtns {
      text-align: right;

      div {
        display: inline-block;
        vertical-align: middle;
        width: 60px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: rgba(0, 69, 197, 0.1);
        color: #0045C5;
        margin-right: 10px;
        cursor: pointer;

        &.delBtn {
          background: rgba(253, 84, 84, 0.1);
          color: #FD5454;
          margin-right: 0;
        }
      }
    }
  }
}
</style>
